"use strict";

exports.__esModule = true;
exports.isNumber = isNumber;

function isNumber(value) {
  return /^\d+$/.test(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/lib/utils/validate/number.js
// module id = IH+J
// module chunks = 0